import React from "react";
import dayjs from 'dayjs'
import _ from 'lodash';
import { CustomMarker, TodayMarker } from 'react-calendar-timeline' // new

/**
 * Displays a marker in between days in the one to two day posted schedule view. Uses the start date it is passed to create
 * the day marker
 * @param {*} startDate
 */
  function DayMarkers({ startDate }) {
    let startDateFixFormat = ''; 
    if (startDate.length == 10){
      startDateFixFormat = startDate.substring(6,10)+'-'+startDate.substring(0,2)+'-'+startDate.substring(3,5);
    }else {
      if(startDate.length == 20 || startDate.length == 25) {
        startDateFixFormat = startDate.substring(0,10);
      } else {
        startDateFixFormat = startDate.year()+'-'+(startDate.month()+1)+'-'+startDate.day().toString().padStart(2,0);
      }
    }
    const startOfFirstDay = dayjs(startDateFixFormat).startOf('day').unix();  
  const endOfFirstDay = dayjs(startOfFirstDay).add(1, 'day').unix();
  const endOfSecondDay = dayjs(startOfFirstDay).add(2, 'day').unix();
    
  return (
    <React.Fragment>
        <CustomMarker date={startOfFirstDay}>
            {({ styles }) => {
              const newStyles = { ...styles, backgroundColor: 'magenta', width: '5px' }
              return <div style={newStyles} />
            }}
        </CustomMarker>

        {/*<TodayMarker interval={4000}>
            {({ styles }) => {
              const newStyles = { ...styles, backgroundColor: 'springgreen', width: '3px' }
              return <div style={newStyles} />
            }}
          </TodayMarker>*/}

        <CustomMarker date={endOfFirstDay}>
            {({ styles }) => {
              const newStyles = { ...styles, backgroundColor: 'magenta', width: '5px' }
              return <div style={newStyles} />
            }}
        </CustomMarker>

        <CustomMarker date={endOfSecondDay}>
            {({ styles }) => {
              const newStyles = { ...styles, backgroundColor: 'magenta', width: '5px' }
              return <div style={newStyles} />
            }}
        </CustomMarker>
  </React.Fragment>
    );
 }

 export default DayMarkers;

